import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/intro/bg.jpg'
import learnSpaceBtn from '../assets/images/intro/learning_space.png'
import completedEndBtn from '../assets/images/intro/play_again.png'

import constant from '../assets/const.json';

class Intro extends Component {

    btnSound = './sounds/button_sound.mp3';
    
    goToGamePage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './game',
            state: {}
        });
    };

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    goToHomePage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './',
            state: {}
        });
    }

    goToStudyAreaPage() {
        this.playBtnSound();
        window.top.location = constant.STUDY_AREA_URL
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img alt='' className='press-btn' src={learnSpaceBtn} style={{ position: 'absolute', height: '13%', right: '57%', bottom: '5.8%' }} onClick={this.goToStudyAreaPage.bind(this)}/>
                <img alt='' className='press-btn' src={completedEndBtn} style={{ position: 'absolute', height: '13%', left: '59%', bottom: '5.8%' }} onClick={this.goToHomePage.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(Intro);
